import React, { useState } from 'react';
import { Box, Grid, Tab, Tabs } from '@mui/material';

import ViewEmailConfigurations from './EmailConfiguration/Email/ViewEmailConfigurations';
import ViewHeaderConfigurations from './EmailConfiguration/Header/ViewHeaderConfigurations';
import ViewFooterConfigurations from './EmailConfiguration/Footer/ViewFooterConfigurations';

const EmailConfigurations = () => {

    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    }

    return <div>
        <Grid container spacing={2}>
            <Grid item xs={6} sm={6} xl={6} lg={6} md={6}>
                <h1 className='page-heading' ><b>Email Configurations</b></h1>
            </Grid>
        </Grid>
        <hr className='blue-border' />
        <Box container sx={{ mt: 4 }}>
            <Tabs value={activeTab} onChange={handleTabChange} aria-label="Email Settings">
                <Tab label="Email Configurations" />
                <Tab label="Header Configurations" />
                <Tab label="Footer Configurations" />
            </Tabs>
            <Box sx={{ p: 2 }}>
                {activeTab === 0 &&
                   <ViewEmailConfigurations />
                }
                {activeTab === 1 &&
                    <ViewHeaderConfigurations />
                }
                {activeTab === 2 &&
                    <ViewFooterConfigurations />
                }
            </Box>
        </Box>
    </div>
}

export default EmailConfigurations;